export const en = {
  acceptYourInvitation: 'Accept your invitation',
  loginToYourBugherdAccount:
    'Login to your BugHerd account to start giving feedback',
  forgotPassword: 'Forgot password?'
};

export type Translations = typeof en;
